import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Languages from '../../models/languages.json';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrl: './terms-of-service.component.scss',
})
export class TermsOfServiceComponent implements OnInit {
  languages: any = Languages;
  selectedLanguage: any;
  currentDate: Date = new Date('2025-07-24');
  teveniEmail = environment.teveniEmail;

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private location: Location,
  ) {}

  ngOnInit() {
    const currentLang = localStorage.getItem('language') || 'en';
    this.selectedLanguage = this.languages.find(
      (lang) => lang.id === currentLang,
    );
  }

  setLanguage(event: any) {
    this.selectedLanguage = event.value;
    localStorage.setItem('language', event.value.id);
    this.translateService.use(event.value.id);
  }

  goBack() {
    this.location.back();
  }

  goToRegister() {
    this.router.navigate(['/register']);
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  goToPrivacyPolicy() {
    this.router.navigate(['/privacy-policy']);
  }

  goToTermsOfService() {
    this.router.navigate(['/terms-of-service']);
  }

  goToSocilMedia(app) {
    if (app == 'instagram') {
      window.open(environment.instagramUrl, '_blank', 'noopener,noreferrer');
    }
    if (app == 'facebook') {
      window.open(environment.facebookUrl, '_blank', 'noopener,noreferrer');
    }
    if (app == 'tiktok') {
      window.open(environment.tiktokUrl, '_blank', 'noopener,noreferrer');
    }
  }
}
